export default __webpack_public_path__ + "static/media/p12.56f709a7.jpg";